<template>
  <div class="sys-notify">
    <!-- <notifyDetails v-if="notifyList.length > 0" ref="notifyDetails" :key="updateKey" :notify-list="notifyList" /> -->
  </div>
</template>

<script>
import notifyDetails from "./components/notifyDetails/index.vue"
import { apiGetAllDimensionSystemMessage, apiSendTestMessage } from "@/api/user"
export default {
  components: { notifyDetails },
  data() {
    return {
      showFtNotify: false,
      updateKey: 1,
      notifyList: []
    }
  },
  mounted() {
    // 获取未读系统消息
    this.getUnreadSysMsg()
  },
  methods: {
    testNotify() {
      // 发送消息
      apiSendTestMessage({ title: "你有一条新消息/新通知！" + new Date(), imAccount: "krrkl1qptf3ondk06ldf", userId: 999 })
    },
    close() {
      this.updateKey = new Date().getTime()
      this.showFtNotify = false
    },
    open() {
      this.showFtNotify = false
      this.$refs.notifyDetails.showModal = true
    },
    // 获取未读系统消息
    getUnreadSysMsg() {
      apiGetAllDimensionSystemMessage().then(res => {
        this.notifyList = res.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sys-notify {
  position: relative;
  z-index: 4000;
}
</style>
